import * as React from "react";
import { SyndeticsMoreInfoContent } from "./syndetics/SyndeticsMoreInfoContent";
import {
  LoaderFunctionArgs,
  redirect,
  useOutletContext,
} from "react-router-dom";
import { SyndeticsTermsLink } from "./syndetics/SyndeticsTermsLink";
import { getRedirectToDefaultTab } from "../resource/ResourcePage";
import {
  getResourceByHostRecordId,
  getResourceById,
} from "../resource/getResourceById";
import { SyndeticsConfigHolder } from "../../SyndeticsConfig";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export async function moreInfoGuard({ request, params }: LoaderFunctionArgs) {
  const titleId = params.titleId;
  const hostRecordId = params.hostRecordId;
  const data = !!titleId
    ? await getResourceById(titleId)
    : await getResourceByHostRecordId(hostRecordId);
  const basePath = !!titleId
    ? `/resource/${titleId}`
    : `/hostrecord/${hostRecordId}`;

  if (data.rtype !== 1) {
    return redirect(`${basePath}/details`);
  }
  const { hasMoreInfoTabEnrichments } = await SyndeticsConfigHolder.getData();
  if (!hasMoreInfoTabEnrichments) {
    const defaultTabPath = await getRedirectToDefaultTab(data);
    return redirect(`${basePath}/${defaultTabPath}`);
  }
  return null; // allow through
}

export const MoreInfoPage: React.FC = () => {
  const resource = useOutletContext<ResourceDWR>();

  return (
    <>
      <SyndeticsMoreInfoContent resource={resource}></SyndeticsMoreInfoContent>
      <SyndeticsTermsLink />
    </>
  );
};
